module.exports = __webpack_public_path__ + "media/images/one-store-2-f3503480e95d589a75d8484906d564dc.jpg";